import { pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { getBaseFields, getBaseIndexes } from '../common/utils'
import { customerMembers } from './customerMember'
import { properties } from './property'

// Customer type enum
export const customerTypeEnum = pgEnum('customer_type', [
  'household',
  'company',
])

// Customer status enum
export const customerStatusEnum = pgEnum('customer_status', [
  'active',
  'paused',
  'churned',
])

export const customers = pgTable(
  'customers',
  {
    ...getBaseFields(),
    name: text().notNull(),
    type: customerTypeEnum().notNull().default('household'),
    status: customerStatusEnum().notNull().default('active'),
    notes: text(),
    stripeCustomerId: text(),
  },
  (table) => getBaseIndexes('customers', table),
)

export const customersRelations = relations(customers, ({ many }) => ({
  members: many(customerMembers),
  properties: many(properties),
}))
